import { render, staticRenderFns } from "./TabbedEditor.vue?vue&type=template&id=835b1c3a&scoped=true&"
import script from "./TabbedEditor.vue?vue&type=script&lang=js&"
export * from "./TabbedEditor.vue?vue&type=script&lang=js&"
import style0 from "./TabbedEditor.vue?vue&type=style&index=0&id=835b1c3a&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./TabbedEditor.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835b1c3a",
  null
  
)

export default component.exports